import { render, staticRenderFns } from "./NotificationPermissionBanner.vue.js?vue&type=template&id=452fd8f9&scoped=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NotificationPermissionBanner.vue?vue&type=template&id=452fd8f9&scoped=true"
import script from "./NotificationPermissionBanner.vue.js?vue&type=script&lang=js!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NotificationPermissionBanner.vue?vue&type=script&lang=js"
export * from "./NotificationPermissionBanner.vue.js?vue&type=script&lang=js!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NotificationPermissionBanner.vue?vue&type=script&lang=js"
import style0 from "./NotificationPermissionBanner.vue.css?vue&type=style&index=0&id=452fd8f9&prod&scoped=true&lang=css!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NotificationPermissionBanner.vue?vue&type=style&index=0&id=452fd8f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452fd8f9",
  null
  
)

export default component.exports